import RandomIcons from './RandomIcons';
import SpreadIcons from './SpreadIcons';

export { RandomIcons, SpreadIcons };



// WEBPACK FOOTER //
// ./src/Components/Elements/Decorations/index.js